import RBush from 'rbush';
import { state } from '__common/store';
import { shouldUseDoublePanels } from './panelsHelper';
import { _isAscenderFamily, _isULA } from '../cursor/utils/snapToGridHelper';

const panelsRTree = new RBush();

interface rTreeBounds {
  id?: number;
  maxX: number;
  maxY: number;
  minX: number;
  minY: number;
  siblingId?: number;
  groupId?: number;
}

export const insertPanelIntoRtree = (panelRTreeBounds: rTreeBounds) => {
  panelsRTree.insert(panelRTreeBounds);
};

export const removePanelFromRtree = (panelRTreeBounds: rTreeBounds) => {
  if (!panelRTreeBounds) return;
  panelsRTree.remove(panelRTreeBounds, (a, b) => {
    return a.id === b.id;
  });
};

export const resetRTree = () => {
  panelsRTree.clear();
};

export const clearRTree = () => {
  panelsRTree.clear();
};

export const checkCollision = (panel: RBush.BBox) => { 
  const { projectConfiguration: { productId } } = state();
  if (shouldUseDoublePanels(productId)) {
    return checkDoublePanelsCollision(panel);
  }

  return checkNormalCollision(panel);
};

export const searchCollisionItems = (bounds: rTreeBounds) => panelsRTree.search(bounds);

function panelCollidesOnlyWithSibling(panel: RBush.BBox, panelsInCollision: RBush.BBox[]) {

  if(_isULA){
    if (panelsInCollision.length === 1 || panelsInCollision.length === 2){
      return panelsInCollision.every((collidedPanel)=>
        panel.siblingId === collidedPanel.siblingId,
      );
    }
  }

  return panelsInCollision.length === 1 && panel.siblingId === panelsInCollision[0].siblingId;
}

function checkNormalCollision(panel: RBush.BBox) {
  const hits = panelsRTree.search(panel);
  const panelId = (panel as rTreeBounds).id;
  if (panelId == null) {
    return hits.length > 0;
  }
  return hits.some(hit => (hit as rTreeBounds).id !== panelId);
}

function checkDoublePanelsCollision(panel: RBush.BBox) {
  const panelId = (panel as rTreeBounds).id;
  const panelsInCollision = panelsRTree.search(panel)
    .filter(hit => panelId == null || (hit as rTreeBounds).id !== panelId);
  if (panelCollidesOnlyWithSibling(panel, panelsInCollision)) {
    return false;
  }
  return panelsInCollision.length > 0;
}
